<template>
	<div class="field">
		<label class="label">{{ label }}</label>
		<div class="control">
			<multiselect
				track-by="value"
				label="label"
				:options="options"
				:multiple="true"
				:close-on-select="false"
				:hide-selected="true"
				:value="myValue"
				:placeholder="placeholder"
				@input="myBlur"
			/>
		</div>
		<p v-if="showError" class="help is-danger">{{ error }}</p>
	</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import fieldMixin from "@lab/utils/fieldMixin";

export default {
	components: { Multiselect },
	mixins: [fieldMixin],
	props: {
		label: {
			type: String,
			default: () => "User"
		},
		options: {
			type: Array,
			required: true
		},
		placeholder: {
			type: String,
			default: () => "Select option"
		}
	},
	computed: {
		myValue() {
			return (this.value || [])
				.map((v) => {
					return this.options.find((opt) => opt.value === v);
				})
				.filter((o) => !!o);
		}
	},
	methods: {
		myBlur(values) {
			const asArray = values.map((v) => v.value);
			this.blur(asArray);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~vue-multiselect/dist/vue-multiselect.min.css";
</style>
